import React from 'react';
import styles from './SummaryControlsWrapper.module.scss';

export default function SummaryControlsWrapper({ children }) {
  return <div className={styles.controls}>{children}</div>;
}
